import { answerStatuses } from '../constants/common';
import { isCloseQuestionRejected } from './isCloseQuestionRejected';
import { needAnswer } from './needAnswer';

export const filterQuestionsFns = {
  byAnswerStatus: (questions, answerStatus) => {
    switch (answerStatus) {
      case answerStatuses.needAnswer.id:
        return questions.filter((question) => needAnswer(question));
      case answerStatuses.notNeedAnswer.id:
        return questions.filter((question) => !needAnswer(question));
      default:
        return questions;
    }
  },

  byReaction: (questions, reactionName) => {
    if (!reactionName) return questions;

    return questions.filter((question) => question.reactionName === reactionName);
  },

  byRejected: (questions) =>
    questions.filter((question) => isCloseQuestionRejected(question)),
};
